import PageHeader from "../components/PageHeader";

const SECTIONS = {
  privacy: [
    ["Information We Collect", "We collect information you provide through our contact, supplier registration, buyer registration and quote forms — including name, company, country, email, phone, product details and any files you upload."],
    ["How We Use It", "Submitted information is used solely to respond to your enquiry, process sourcing requests and communicate about your requirements. We do not sell your data."],
    ["File Uploads", "Documents such as company profiles, catalogues and drawings are stored securely and accessed only by our sourcing team to fulfil your request."],
    ["Data Retention", "We retain enquiry data for as long as necessary to serve you and to meet legal and operational requirements."],
    ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting us."],
    ["Contact", "For any privacy questions, email info@sourcex-global.com."],
  ],
  terms: [
    ["Acceptance of Terms", "By using the SourceX Global website you agree to these terms and conditions in full."],
    ["Services", "SourceX Global provides sourcing and procurement facilitation services connecting global buyers with Indian manufacturers. Quotes are indicative until confirmed in writing."],
    ["Quotations & Orders", "All quotations are subject to supplier confirmation, material availability and final specifications. Orders proceed only upon mutual written agreement."],
    ["Intellectual Property", "Drawings and specifications you share remain your property and are used solely to fulfil your sourcing request under confidentiality."],
    ["Limitation of Liability", "SourceX Global facilitates sourcing in good faith and is not liable for indirect or consequential losses beyond the scope of agreed services."],
    ["Governing Law", "These terms are governed by the laws of India. Questions: info@sourcex-global.com."],
  ],
};

export default function Legal({ variant = "privacy" }) {
  const isPrivacy = variant === "privacy";
  const items = SECTIONS[variant];
  return (
    <div data-testid={`${variant}-page`}>
      <PageHeader
        overline="Legal"
        title={isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
        subtitle={isPrivacy ? "How SourceX Global collects, uses and protects your information." : "The terms that govern your use of SourceX Global."}
      />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-24 md:py-32 space-y-12">
        {items.map(([t, d], i) => (
          <div key={t}>
            <div className="font-mono text-brand-orange text-sm mb-3">0{i + 1}</div>
            <h2 className="font-display font-bold text-2xl mb-3">{t}</h2>
            <p className="text-muted-foreground leading-relaxed">{d}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
